// removed by extract-text-webpack-plugin
module.exports = {"Layout":"Layout__Layout__1SGjM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Layout.css
// module id = 57
// module chunks = 0